import {useLocation, useNavigate} from "react-router-dom";
import {TabBar} from "antd-mobile";
import { getBottomNavBarContainerStyle } from "../../../utils/deviceUtils";

export type PickUpItem = {
    path: string;
    icon: React.ReactNode;
    label: string;
}

interface PickUpPathNavigationTabBarProps {
    items: PickUpItem[];
}


export const PickUpPathNavigationTabBar: React.FC<PickUpPathNavigationTabBarProps> = ({items}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {pathname} = location;

    const setRouteActive = (value: string) => {
        navigate(value);
    };

    return (
        <div className="flex-none border-t border-gray-300">
            <TabBar activeKey={pathname} onChange={value => setRouteActive(value)}>
                {
                    items.map(item => (
                        <TabBar.Item key={item.path} icon={item.icon} title={item.label}/>
                    ))
                }
            </TabBar>
        </div>
    );
};

export default PickUpPathNavigationTabBar;